module.exports = __webpack_public_path__ + "static/media/slider1-02.5b219278.jpg";